import { gql } from "graphql-tag";

export const GET_LOCATIONS = gql`
  query GetLocations(
    $pagination: PaginationInput
    $filter: LocationFilterInput
    $sort: LocationSortInput
  ) {
    locations(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        id
        name
        categoryId
        category {
          id
          name
          color
        }
        accountId
        street
        zip
        city
        country
        phone
        isTemplate
        latitude
        longitude
        createdAt
        updatedAt
        assetCount
        userCount
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_LOCATION = gql`
  query GetLocation($id: ID!) {
    location(id: $id) {
      id
      name
      categoryId
      category {
        id
        name
        color
      }
      accountId
      street
      zip
      city
      country
      phone
      isTemplate
      latitude
      longitude
      createdAt
      updatedAt
    }
  }
`;
